module.exports = __webpack_public_path__ + "media/assets/images/authors/paolo_brasolin-00ecde0a6b987120f2dc95c175475081.jpg";